import React, { useEffect } from 'react'
import { faCheck, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcOverlaySlider,
  PixelIcon,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'

import { getSuppliers } from 'utils/api-routes.util'

import AddSupplier from './components/AddSupplier'
import { ISupplier } from '../../../../../decl'

const breadcrumbs = [
  {
    name: 'Manage Suppliers',
    active: true,
  },
]
const Supplier = () => {
  const [addNewSupplierModal, setAddNewSupplierModal] = React.useState(false)
  const [suppliers, setSuppliers] = React.useState<ISupplier[]>([])
  const [tableLoading, setTableLoader] = React.useState(true)
  const getAllSuppliers = () => {
    setTableLoader(true)
    getSuppliers().subscribe((res) => {
      const response = res.response as { data: ISupplier[] }
      setSuppliers(response.data)
      setTableLoader(false)
    })
  }

  useEffect(() => {
    getAllSuppliers()
  }, [])
  const columns = [
    {
      dataKey: 'supplier_name',
      name: 'Supplier Name',
      sortable: true,
      selector: (row) => row.supplier_name || '--',
    },
    {
      dataKey: 'contact_person',
      name: 'Contact Person',
      sortable: true,
      selector: (row) => row.contact_person || '--',
    },
    {
      dataKey: 'supplier_contact',
      name: 'Phone',
      sortable: true,
      selector: (row) => row.supplier_contact || '--',
    },
    {
      dataKey: 'supplier_address',
      name: 'Address',
      sortable: true,
      selector: (row) => row.supplier_address || '--',
    },
    {
      dataKey: 'is_active',
      name: 'Is Active ?',
      sortable: true,
      selector: (row) => (
        <PixelIcon
          icon={row.active ? faCheck : faXmark}
          color={row.active ? 'green' : 'red'}
        />
      ),
    },
  ]
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="auto"
              padding="5px 20px"
              justifyContent="flex-end"
              alignItems="center"
            >
              <DcButton
                size="sm"
                onClick={() => {
                  setAddNewSupplierModal(true)
                }}
              >
                <PixelIcon color="white" icon={faPlus} />
                &nbsp; Add Supplier
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={suppliers}
              progressPending={tableLoading}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcOverlaySlider
        title={'Add New Supplier'}
        width="30%"
        isOpen={addNewSupplierModal}
        onClose={() => setAddNewSupplierModal(false)}
      >
        {addNewSupplierModal && (
          <SectionContent>
            <AddSupplier
              handleClose={(res: ISupplier) => {
                setSuppliers([res, ...suppliers])
                setAddNewSupplierModal(false)
              }}
            />
          </SectionContent>
        )}
      </DcOverlaySlider>
    </>
  )
}

export default Supplier
